<template>
  <div class="resourceIndex">
    <div class="leftTabsBox">
      <div class="leftTabs">
          <left-tabs @indexOpenTab="indexOpenTab" @indexResourse="indexResourse"></left-tabs>
      </div>
    </div>
    <div class="banner">
      <banner></banner>
    </div>
    <div class="logoNav" v-if="isshow">
      <Row style="width: 80%;">
        <Col span='6' >
          <div class="inBox borderLine" >
            <div class="imgIcon">
              <img src="/static/images/weike.png" alt="">
            </div>
            <div class="itemNumber">
              <div class="itemTitle">动漫微课</div>
              <div class="itemNum">6352<span>节</span></div>
            </div>
          </div>
        </Col>
       <Col span='6' >
          <div class="inBox borderLine" >
            <div class="imgIcon">
              <img src="/static/images/gongkaike.png" alt="">
            </div>
            <div class="itemNumber">
              <div class="itemTitle">公开课</div>
              <div class="itemNum">13623<span>节</span></div>
            </div>
          </div>
        </Col><Col span='7' >
          <div class="inBox borderLine" >
            <div class="imgIcon">
              <img src="/static/images/xiti.png" alt="">
            </div>
            <div class="itemNumber">
              <div class="itemTitle">习题</div>
              <div class="itemNum">1563576<span>道</span></div>
            </div>
          </div>
        </Col><Col span='5' >
          <div class="inBox" >
            <div class="imgIcon">
              <img src="/static/images/ziyuan.png" alt="">
            </div>
            <div class="itemNumber">
              <div class="itemTitle">资源总数</div>
              <div class="itemNum">1602857</div>
            </div>
          </div>
        </Col>
      </Row>
    </div>
    <div id="content">
       <index-micro @routerMicroName="routerMicroName"  @showPlayer="showPlayer"></index-micro>
       <index-open @routerMicroName="routerMicroName" @indexOpen="indexOpen"></index-open>
       <index-package @routerMicroName="routerMicroName" @indexPackage="indexPackage"></index-package>
       <!-- <index-area @routerMicroName="routerMicroName" @showPlayer="showPlayer"></index-area> -->
       <index-regional @isplay="isplay" @routerMicroName="routerMicroName"></index-regional>
    </div>
    <video-player v-if="isPlayer" @closePlayer="closePlayer"></video-player>
    <play-material v-show="isPlayMaterial" @closePlayer="closePlayer"></play-material>
  </div>
</template>

<script>
import api from '../utils/api.js';
import bus from '../assets/eventBus/enentBus.js';
import LeftTabs from './index/LeftTabs.vue'
import IndexMicro from './index/IndexMicro.vue'
import Banner from './index/Banner.vue'
import IndexOpen from './index/IndexOpen.vue'
import IndexArea from './index/IndexArea.vue'
import IndexPackage from './index/IndexPackage.vue'
import IndexRegional from './index/IndexRegional.vue'
import VideoPlayer from './videoPlayer/viderPlayer.vue'
import PlayMaterial from './playMaterial/playMaterial.vue'
export default {
  name: 'index',
  data () {
    return {
      msg: '',
      isPlayer:false,
      routerName:null,
      indexOpenName:null,
      isPlayMaterial:false,
      isshow:true
    }
  },
  mounted(){
    this.isshow = location.host === 'syht.res.aixueyun.cn' ? false:true
  },
  methods:{
    showPlayer(obj){
        this.isPlayer = obj;            //打开播放器  ture
    },
    isplay(msg){
        //console.log('是否点击材料',msg)
        this.isPlayMaterial = msg;
    },
    closePlayer(msg){
        this.isPlayMaterial = msg;
        this.isPlayer = msg;
    },
    routerMicroName(msg){
      this.routerName = msg;
      this.$emit('routerName',this.routerName)
    },
    indexOpen(msg){
      let that = this;
      this.indexOpenName = msg;
      this.$emit('fromIndexOpen',msg);
    },
    indexPackage(msg){
      //console.log(msg)
      this.$emit('fromIndexPackage',msg);
    },
    indexResourse(msg){
      this.$emit('fromIndexResourse',msg);
    },
    indexOpenTab(msg){
      this.$emit('fromIndexOpenTab',msg);
    }
  },
  components:{LeftTabs,Banner,IndexMicro,IndexOpen,IndexPackage,IndexArea,IndexRegional,VideoPlayer,PlayMaterial}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.resourceIndex {
  position: relative;
}
.leftTabsBox {
  width: 100%;
  height: 0;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 99;
}
.resourceIndex .leftTabs {
  width: 87.4%;
  margin: 0 auto;
}
.banner {
  height: auto;
  /* margin-top: -28px; */
}
.logoNav {
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 87.4%;
  margin: 30px auto;
}
/* .logoNav .logocon {
  flex: 2;
} */
.logoNav img {
  height:44px ;
}
.inBox{
  display: flex;
  flex-direction: row;
}
.imgIcon{
  flex: 2;
  text-align: right;
  padding-right: 20px;
}
.imgIcon img{
  width:50px;
  height: 50px;
}
.itemNumber{
  flex: 3;
  /* padding-left: 20px; */
}
.itemNumber .itemTitle{
  height: 25px;
  line-height: 25px;
  text-align: left;
  font-size: 18px;
  font-weight: 500;
}
.itemNum{
  text-align: left;
  font-size: 22px;
  color: #3583FF;
  font-weight: 600;
}
.itemNum span{
  font-size: 14px;
  padding-left: 5px;
  color: #999999;
  font-weight: 400;
}
.borderLine{
  border-right: solid 1px #DAE6F7;
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue